export enum InputType {
  Text = 'text',
  Password = 'password',
  Number = 'number',
  Email = 'email',
  Tel = 'tel',
  Url = 'url',
  Search = 'search',
  Date = 'date',
  Time = 'time',
  DatetimeLocal = 'datetime-local',
  Month = 'month',
  Week = 'week',
}
